import ItemContainer from '@/components/ItemContainer.vue';
import NavigationFooter from '@/components/NavigationFooter.vue';
import DisplayItem from '@/models/DisplayItem';
import Item from '@/models/Item';
import DeliveryOptionConstants from '../options/DeliveryOptionConstants';
import DeliveryOptionUtility from '../options/DeliveryOptionUtility';

class DisplayManager {
  itemToolbarVisible(visible: boolean, itemContainer: ItemContainer | undefined | null): void {
    if (itemContainer) {
      itemContainer.addTopBorderRadius(!visible);
      itemContainer.setAdjustmentHeight(visible ? 58 : 0);
    }
  }

  itemContainerHeightChange(
    value: number,
    itemContainer: ItemContainer | undefined | null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    navigationFooter: NavigationFooter | undefined | null
  ): void {
    if (itemContainer) {
      itemContainer.adjustBottomLayout(false);
    }
  }

  showItemToolbar(item: DisplayItem | undefined | null): boolean {
    let itemOptionsPresent = false;
    let textToSpeechOptionPresent = false;
    if (item) {
      if (item instanceof Item) {
        itemOptionsPresent = item.deliveryOptions.length > 0;
      }
      textToSpeechOptionPresent =
        DeliveryOptionUtility.getDeliveryOption(
          item.section.testPart.deliveryOptions,
          DeliveryOptionConstants.TEXT_TO_SPEECH
        ) !== undefined;
    }
    return itemOptionsPresent || textToSpeechOptionPresent;
  }
}

export default DisplayManager;
